import React from "react";
// BASE Components
import BASELoading from "../../../../../../../@BASE/core/BASELoading";
// Material UI
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
// Custom Components
import { ImageAttribution } from "../components/ImageAttribution";
import EMentor from "../components/EMentor";
import JobAideStatement from "../components/JobAideStatement";
import Instructions from "../components/Instructions";
import ComponentCard from "../components/Component";
import ComponentPreview from "../components/Preview";
import ComponentStepLabel from "../components/StepLabel";
import SubComponentCard from "../components/SubComponent";
import SummaryInstructions from '../components/SummaryInstructions';

export default function LessonSummary(props) {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  const noFeedbackInstructions = (ins, type) => {
    const pickInstructions = (key) => {
      return ins.filter((data) => data.label.includes(`-${key}`));
    };

    switch (type) {
      case "0": {
        return pickInstructions("variation-1-");
      }
      case "1": {
        return pickInstructions("variation-5");
      }
      case "2": {
        return pickInstructions("variation-9");
      }
      case "3": {
        return pickInstructions("variation-13");
      }
      case "4": {
        return pickInstructions("variation-17");
      }
      case "5": {
        return pickInstructions("variation-21");
      }
      case "6": {
        return pickInstructions("variation-25");
      }
      case "7": {
        return pickInstructions("variation-29");
      }
    }
  };

  const lowFeedbackInstructions = (ins, type) => {
    const pickInstructions = (key) => {
      return ins.filter((data) => data.label.includes(`-${key}`));
    };

    switch (type) {
      case "0": {
        return pickInstructions("variation-2-");
      }
      case "1": {
        return pickInstructions("variation-6");
      }
      case "2": {
        return pickInstructions("variation-10");
      }
      case "3": {
        return pickInstructions("variation-14");
      }
      case "4": {
        return pickInstructions("variation-18");
      }
      case "5": {
        return pickInstructions("variation-22");
      }
      case "6": {
        return pickInstructions("variation-26");
      }
      case "7": {
        return pickInstructions("variation-30");
      }
    }
  };

  const midFeedbackInstructions = (ins, type) => {
    const pickInstructions = (key) => {
      return ins.filter((data) => data.label.includes(`-${key}`));
    };

    switch (type) {
      case "0": {
        return pickInstructions("variation-3-");
      }
      case "1": {
        return pickInstructions("variation-7");
      }
      case "2": {
        return pickInstructions("variation-11");
      }
      case "3": {
        return pickInstructions("variation-15");
      }
      case "4": {
        return pickInstructions("variation-19");
      }
      case "5": {
        return pickInstructions("variation-23");
      }
      case "6": {
        return pickInstructions("variation-27");
      }
      case "7": {
        return pickInstructions("variation-31");
      }
    }
  };

  const highFeedbackInstructions = (ins, type) => {
    const pickInstructions = (key) => {
      return ins.filter((data) => data.label.includes(`-${key}`));
    };

    switch (type) {
      case "0": {
        return pickInstructions("variation-4");
      }
      case "1": {
        return pickInstructions("variation-8");
      }
      case "2": {
        return pickInstructions("variation-12");
      }
      case "3": {
        return pickInstructions("variation-16");
      }
      case "4": {
        return pickInstructions("variation-20");
      }
      case "5": {
        return pickInstructions("variation-24");
      }
      case "6": {
        return pickInstructions("variation-28");
      }
      case "7": {
        return pickInstructions("variation-32");
      }
    }
  };

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  return (
    <div>
      <style>
        {`
          .wysiwyg p {
            margin: 0px;
          }
        `}
      </style>

      <Instructions ins={ins.filter(data => data.label.includes("default"))} course={course} dir={dir} tl={tl} componentCommentsCount={componentCommentsCount} />
      
      <ComponentCard title="Objective" id={data.core.id} commentsCount={componentCommentsCount(data.core.id)}>
        {/* <ComponentPreview>
          <ObjectiveItem objective={objective} index={index} diagram />
        </ComponentPreview> */}
        <ComponentStepLabel number="1" title="Image:" />
        <ImageAttribution attribution={data.core.media} tl={tl} dir={dir} />

        <ComponentStepLabel number="2" title="Objective:" />
        <SubComponentCard
          title="Objective"
          id={data.core.id + "objective"}
          commentsCount={componentCommentsCount(data.core.id + "objective")}
        >
          <Paper elevation={0} square className="p-16">
            <Grid container spacing={1}>
              <Grid item xs={12} sm={4} lg={2}>
                <Typography className="text-14 font-semibold m-0">
                  Text (TL):
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8} lg={10}>
                <Typography className="text-14 m-0">
                  {data.core.text_tl}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4} lg={2}>
                <Typography className="text-14 font-semibold m-0">
                  Text (EN):
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8} lg={10}>
                <Typography className="text-14 m-0">
                  {data.core.text_en}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </SubComponentCard>
      </ComponentCard>

      {data.item_feedback.map((feedback, index) => (
        <ComponentCard key={feedback.id} title={feedback.title_en} id={feedback.id} commentsCount={componentCommentsCount(feedback.id)}>
          <SubComponentCard title="No Attempt" id={feedback.id + "nf"} commentsCount={componentCommentsCount(feedback.id + "nf")}>
            <SummaryInstructions ins={noFeedbackInstructions(ins, feedback.interaction_type)} course={course} dir={dir} tl={tl} componentCommentsCount={componentCommentsCount} />
          </SubComponentCard>

          <SubComponentCard title="Low Feedback" id={feedback.id + "lf"} commentsCount={componentCommentsCount(feedback.id + "lf")}>
            <SummaryInstructions ins={lowFeedbackInstructions(ins, feedback.interaction_type)} course={course} dir={dir} tl={tl} componentCommentsCount={componentCommentsCount} />
          </SubComponentCard>

          <SubComponentCard title="Mid Feedback" id={feedback.id + "mf"} commentsCount={componentCommentsCount(feedback.id + "mf")}>
            <SummaryInstructions ins={midFeedbackInstructions(ins, feedback.interaction_type)} course={course} dir={dir} tl={tl} componentCommentsCount={componentCommentsCount} />
          </SubComponentCard>

          <SubComponentCard title="High Feedback" id={feedback.id + "hf"} commentsCount={componentCommentsCount(feedback.id + "hf")}>
            <SummaryInstructions ins={highFeedbackInstructions(ins, feedback.interaction_type)} course={course} dir={dir} tl={tl} componentCommentsCount={componentCommentsCount} />
          </SubComponentCard>
        </ComponentCard>
      ))}

      <ComponentCard
        title="Job Aid"
        id="jobAid"
        commentsCount={componentCommentsCount("jobAid")}
      >
        <SubComponentCard
          title="Job Aid Feedback"
          id="jaf"
          commentsCount={componentCommentsCount("jaf")}
        >
          <Paper elevation={0} square className="p-16">
            <Grid container spacing={1}>
              <Grid item xs={12} sm={4} lg={2}>
                <Typography className="text-14 font-semibold m-0">
                  No Job Aid (TL):
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8} lg={10}>
                <Typography className={`${tl} m-0`} dir={dir}>
                  {data.core.no_jobaid_tl}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4} lg={2}>
                <Typography className="text-14 font-semibold m-0">
                  No Job Aid (EN):
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8} lg={10}>
                <Typography className="text-14 m-0">
                  {data.core.no_jobaid_en}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Divider className="my-8" />
              </Grid>
              <Grid item xs={12} sm={4} lg={2}>
                <Typography className="text-14 font-semibold m-0">
                  Yes Job Aid (TL):
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8} lg={10}>
                <Typography className={`${tl} m-0`} dir={dir}>
                  {data.core.yes_jobaid_tl}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4} lg={2}>
                <Typography className="text-14 font-semibold m-0">
                  Yes Job Aid (EN):
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8} lg={10}>
                <Typography className="text-14 m-0">
                  {data.core.yes_jobaid_en}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </SubComponentCard>

        <SubComponentCard
          title="Job Aid Content"
          id="jac"
          commentsCount={componentCommentsCount("jac")}
        >
          <Paper elevation={0} square className="p-16">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                {data.core.jobaid_pdf_lead_tl && (
                  <Typography
                    className={`${tl} m-0 wysiwyg`}
                    dir={dir}
                    dangerouslySetInnerHTML={{
                      __html: data.core.jobaid_pdf_lead_tl,
                    }}
                  />
                )}

                {data.core.jobaid_pdf_lead_en && (
                  <Typography
                    className="m-0 text-14 wysiwyg"
                    dangerouslySetInnerHTML={{
                      __html: data.core.jobaid_pdf_lead_en,
                    }}
                  />
                )}

                <Divider className="my-16" />

                {data.jobaid_pdf && data.jobaid_pdf.length !== 0 && (
                  <JobAideStatement
                    statements={data.jobaid_pdf}
                    tl={tl}
                    dir={dir}
                  />
                )}
              </Grid>
            </Grid>
          </Paper>
        </SubComponentCard>
      </ComponentCard>

      {data.eMentor.length !== 0 && (
        <EMentor
          eMentor={data.eMentor}
          tl={tl}
          dir={dir}
          componentCommentsCount={componentCommentsCount}
        />
      )}
    </div>
  );
}
